import { Box, MenuItem, Typography } from '@mui/material';
import { Search } from '@mui/icons-material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import {
  CustomTextField,
  CustomSelect,
  CustomButton,
  HorizontalForm,
  LabelContent,
} from '../../../common/components';

const LifeInsuranceHeader = ({
  filter,
  plans,
  groups,
  onFilter,
  onSearch,
  onDownloadExcel,
  onDownloadExcelForInsurer,
  isLoading,
  selectedFile,
  onFileUpload,
  onImportValues,
}) => {
  return (
    <HorizontalForm withBorder={false} sx={{ paddingTop: 1, gap: 4 }} variant="twoRows">
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <CustomTextField
          label="Cuota pura"
          name="cuotaPura"
          value={filter.cuotaPura}
          onChange={onFilter}
          required
          error={!filter.cuotaPura}
          size="medium"
        />

        <CustomSelect
          label="Plan"
          labelId="plan-label"
          id="plan-select"
          name="plan"
          value={filter.plan}
          onChange={onFilter}
          displayEmpty
          size="medium"
        >
          <MenuItem value="">Todos</MenuItem>
          {plans.map((plan) => (
            <MenuItem key={plan.uuid} value={plan.uuid}>
              {plan.name}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomSelect
          label="Grupo"
          labelId="group-label"
          id="group-select"
          name="group"
          value={filter.group}
          onChange={onFilter}
          displayEmpty
          size="medium"
        >
          <MenuItem value="">Todos</MenuItem>
          {groups.map((group) => (
            <MenuItem key={group.uuid} value={group.uuid}>
              {group.name}
            </MenuItem>
          ))}
        </CustomSelect>

        <CustomButton
          variant="base"
          onClick={onSearch}
          startIcon={<Search />}
          disabled={!filter.cuotaPura}
          sx={{ padding: '10px 30px', mt: 1.5, minWidth: '150px' }}
        >
          Buscar
        </CustomButton>

        <CustomButton
          variant="base"
          onClick={onDownloadExcel}
          startIcon={<CloudDownloadIcon />}
          disabled={!filter.cuotaPura || isLoading}
          sx={{ padding: '10px 30px', mt: 1.5, minWidth: '150px' }}
        >
          Exportar
        </CustomButton>

        <CustomButton
          variant="base"
          onClick={onDownloadExcelForInsurer}
          startIcon={<CloudDownloadIcon />}
          disabled={!filter.cuotaPura || isLoading}
          sx={{ padding: '10px 30px', mt: 1.5, minWidth: '200px' }}
        >
          Descarga para aseguradora
        </CustomButton>
      </Box>

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', paddingTop: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
            Importar Datos
          </Typography>

          <LabelContent
            variant="body2"
            sx={{ color: 'text.secondary', maxWidth: '300px' }}
            content="El archivo debe contener la estructura de columnas del archivo exportado."
            separator=""
          />
        </Box>

        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
          <input
            type="file"
            accept=".xlsx"
            onChange={onFileUpload}
            style={{ display: 'none' }}
            id="fileUpload"
          />

          <label htmlFor="fileUpload">
            <CustomButton variant="base" component="span" startIcon={<FileUploadIcon />}>
              Seleccionar
            </CustomButton>
          </label>

          <CustomButton variant="warning" onClick={onImportValues} disabled={!selectedFile}>
            Importar
          </CustomButton>

          <LabelContent
            variant="body2"
            sx={{ fontSize: '14px', ml: 1 }}
            content={selectedFile ? selectedFile.name : 'Sin archivos seleccionados'}
            separator=""
          />
        </Box>
      </Box>
    </HorizontalForm>
  );
};

export default LifeInsuranceHeader;
